module.exports = __webpack_public_path__ + "static/media/1.6b9972bc.webp";